// Korfine person numbers, mirroring WinApp CodeHelper.IsNationalRegister / NormalizeNationalRegister
// and UCKorfine.GetRegistrationNumber.

// WinApp CodeHelper.RemoveSeperateCharacter strips . + / - and spaces.
const NATIONAL_REGISTER_SEPARATORS = /[.+/\- ]/g;
const NATIONAL_REGISTER_DIGITS = /^\d{11}$/;

// Optional field: empty or blank is valid; otherwise 11 digits once the separators are removed.
export function isValidNationalRegister(value?: string | null): boolean {
    return !value?.trim() || NATIONAL_REGISTER_DIGITS.test(value.replace(NATIONAL_REGISTER_SEPARATORS, ""));
}

// XX.XX.XX-XXX.XX for a valid number; a blank value becomes ""; anything else is returned unchanged.
export function normalizeNationalRegister(value?: string | null): string | null | undefined {
    if (value && !value.trim()) {
        return "";
    }
    const digits = value?.replace(NATIONAL_REGISTER_SEPARATORS, "");
    if (!digits || !NATIONAL_REGISTER_DIGITS.test(digits)) {
        return value;
    }
    return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4, 6)}-${digits.slice(6, 9)}.${digits.slice(9)}`;
}

// Korfine expects the enterprise number with its country code: a number of only digits, spaces
// and dots is Belgian, so it gets "BE" in front.
export function korfineRegistrationNumber(value?: string | null): string | null | undefined {
    const trimmed = value?.trim();
    if (!trimmed) {
        return value ? "" : value;
    }
    return /^[\d\s.]+$/.test(trimmed) ? `BE${trimmed}` : trimmed;
}
